import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { ExpandableCellProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { Icon } from "components/common";
import { TableCell } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ExpandableCell: React.FC<ExpandableCellProps> = ({ expanded, className }) => {
  return (
    <TableCell className={clsx(cssExports.tableCell, cssExports.expansionCell, className)}>
      {expanded ? (
        <Icon icon={IconDefinitionConstants.WChevronSmallDown} />
      ) : (
        <Icon icon={IconDefinitionConstants.WChevronSmallRight} />
      )}
    </TableCell>
  );
};

export default ExpandableCell;
